<template>
    <div class="mt-5">
        <hr class="border-gray-200 dark:border-gray-800">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-5">
            <router-link
                class="relative cursor-pointer bg-white border border-gray-200 rounded-lg shadow-md md:mx-1 my-3 dark:bg-gray-900 dark:border-gray-800"
                v-for="(bien, index) in biens" :key="index"
                :to="`/bien/${bien.uuid}`"
            >
                <div class="rounded-t-lg" v-if="bien.images">
                    <img class="rounded-t-lg" src="/docs/images/blog/image-1.jpg" alt="" />
                </div>
                <div class="rounded-t-lg h-64 md:h-48 bg-gray-200 dark:bg-gray-800 flex justify-center items-center" v-else>
                    <font-awesome-icon class="text-3xl text-gray-600 dark:text-gray-400" :icon="['fa', defaultIcon(bien)]" />
                </div>

                <span
                    v-if="bien.total_cumule !== undefined && bien.total_cumule !== null"
                    class="absolute top-2 left-2 px-2 py-1 rounded-md text-xs font-semibold shadow bg-white/90 dark:bg-gray-900/90"
                    :class="bien.total_cumule >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'"
                >{{ formatMoney(bien.total_cumule) }}</span>

                <div class="p-5">
                    <h3 class="text-indigo-500 dark:text-indigo-400 cursor-pointer inline-block text-lg">{{bien.libelle}}</h3>

                    <div class="my-3 text-sm font-normal text-gray-500 dark:text-gray-400">
                        <p>{{ bien.ville }}
                            <template v-if="bien.ville && bien.cp"> - </template>{{ bien.cp }}</p>
                        <p>{{ bien.adresse }}</p>
                    </div>
                </div>
            </router-link>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        biens: {
            type: Array,
            default() {
                return []
            }
        },
    },

    methods: {
        defaultIcon(bien) {
            if (bien.type === 'appartement') {
                return 'building'
            }

            if (bien.type === 'immeuble') {
                return 'hotel'
            }

            return 'home';
        },

        formatMoney(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }
    }
};
</script>